import { z } from 'zod'

export const operatoryIdSchema = z.union([
  z.string().refine((value) => value.trim().length > 0),
  z.number().finite(),
])

const operatorySchema = z
  .object({
    id: operatoryIdSchema,
    name: z.string().trim().min(1),
  })
  .strict()

export const operatoryPolicyPayloadSchema = z
  .object({
    blockedOperatories: z.array(operatoryIdSchema),
    trueOverlappingOperatorySlots: z.boolean(),
  })
  .strict()

export const operatoryPolicyResponseSchema = operatoryPolicyPayloadSchema
  .extend({
    operatories: z.record(operatorySchema).nullable(),
  })
  .strict()

export type OperatoryId = z.infer<typeof operatoryIdSchema>
export type OperatoryPolicyPayload = z.infer<
  typeof operatoryPolicyPayloadSchema
>
export type OperatoryPolicyResponse = z.infer<
  typeof operatoryPolicyResponseSchema
>
